import { AddressUtils } from "@utils/address/index";
import { api, temp, ui } from "../../../../../../../../../interfaces/interfaces";

export const handlePostCodeChange = (e: any) => {
  if (e.target.value.length > 5) {
    ui.ProblemInputPostcode = AddressUtils.formatPostcode(e.target.value.toUpperCase());
  } else {
    ui.ProblemInputPostcode = e.target.value.toUpperCase();
  }
};

export const handleKeyPress = (ev: { key: string; preventDefault: () => void }) => {
  if (ev.key === "Enter") {
    ev.preventDefault();
    if (temp.ProblemAddressActiveSearch) AddressUtils.searchAddressesProblem({ temp, ui, api });
  }
};
